import { Routes } from '@angular/router';
import { OntologyManagerComponent } from './ontology-manager.component';
import { VariablesPaneComponent } from './tabs/variables/variables-pane.component';
import { PropertiesPaneComponent } from './tabs/properties/properties-pane.component';
import { MethodsPaneComponent } from './tabs/methods/methods-pane.component';
import { ScalesPaneComponent } from './tabs/scales/scales-pane.component';
import { ONTOLOGY_MANAGER_PERMISSIONS } from '../shared/auth/permissions';
import { RouteAccessService } from '../shared';
import { MethodPopupComponent } from './tabs/methods/method-dialog.component';
import { PropertyPopupComponent } from './tabs/properties/property-dialog.component';
import { ScalePopupComponent } from './tabs/scales/scale-dialog.component';
import { VariablePopupComponent } from './tabs/variables/variable-dialog.component';

export const ONTOLOGY_MANAGER_ROUTES: Routes = [
    {
        path: 'ontology-manager',
        component: OntologyManagerComponent,
        data: { authorities: [...ONTOLOGY_MANAGER_PERMISSIONS] },
        canActivate: [RouteAccessService],
        children: [
            {
                path: '',
                redirectTo: 'variables-pane',
                pathMatch: 'full'
            },
            {
                path: 'variables-pane',
                component: VariablesPaneComponent
            },
            {
                path: 'properties-pane',
                component: PropertiesPaneComponent
            },
            {
                path: 'methods-pane',
                component: MethodsPaneComponent
            },
            {
                path: 'scales-pane',
                component: ScalesPaneComponent
            }
        ]
    },
    {
        path: 'variables/:id/view',
        component: VariablePopupComponent,
        outlet: 'popup'
    },
    {
        path: 'variables/new',
        component: VariablePopupComponent,
        outlet: 'popup'
    },
    {
        path: 'properties/:id/view',
        component: PropertyPopupComponent,
        outlet: 'popup'
    },
    {
        path: 'variables/:variableId/properties/:id/view',
        component: PropertyPopupComponent,
        outlet: 'popup'
    },
    {
        path: 'properties/new',
        component: PropertyPopupComponent,
        outlet: 'popup'
    },
    {
        path: 'methods/:id/view',
        component: MethodPopupComponent,
        outlet: 'popup'
    },
    {
        path: 'variables/:variableId/methods/:id/view',
        component: MethodPopupComponent,
        outlet: 'popup'
    },
    {
        path: 'methods/new',
        component: MethodPopupComponent,
        outlet: 'popup'
    },
    {
        path: 'scales/:id/view',
        component: ScalePopupComponent,
        outlet: 'popup'
    },
    {
        path: 'variables/:variableId/scales/:id/view',
        component: ScalePopupComponent,
        outlet: 'popup'
    },
    {
        path: 'scales/new',
        component: ScalePopupComponent,
        outlet: 'popup'
    }
];
